import { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AddToCart from "../AddToCart/AddToCart";
import AddToCartQty from "../AddToCart/AddToCartQty";
import { store } from "../../Helper/Context/Store";
import "./ProductCard.css";
export default function ProductCard1({ productData, isInCart }) {
  const [variantId, setVariantId] = useState(null);
  const [variantName, setVariantName] = useState(null);
  const [itemName, setItemName] = useState(null);
  const [MRP, setMRP] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  // const { cartItems } = useContext(store)

  useEffect(() => {
    try {
      setItemName(productData?.fld_variantname);
      setMRP(productData?.fld_mrp);
      setDiscountPrice(productData?.fld_website_discount_price);
      setVariantId(productData?.fld_variantid);
      setVariantName(productData?.fld_variantname1);
      setCategoryName(productData?.fld_verticlename ? productData?.fld_verticlename : productData?.fld_categoryname);

    } catch {
      try {
        setItemName(productData?.fld_variantname);
        setMRP(productData?.fld_mrp);
        setDiscountPrice(productData?.fld_website_discount_price);
        setVariantId(productData?.fld_variantid);
        setVariantName(productData?.fld_variantname1);
        // setCategoryName(productData?.fld_categoryname);
        setCategoryName(productData?.fld_verticlename ? productData?.fld_verticlename : productData?.fld_verticlename);
      } catch { }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData]);
  return (
    <div className="product-card ">
      {/* {console.log(productData.fld_route)} */}
      <Link
        to={`${process.env.PUBLIC_URL
          }/p/${productData.fld_route?.replace(
            /\s/g,
            "-"
          ).replace('/', '')}`}
      // to={`/productdetail/${itemName?.replace(
      //   /\s/g,
      //   "-"
      // )}-${variantName?.replace(/\s/g, "-")}/${variantId}`}
      >
        <img
          alt={itemName}
          src={productData.VariantImage}
          // src="https://www.theamethyststore.com/cdn/shop/files/AMS-102-1764_1.jpg?v=1689851997&width=540"
          className="img-fluid border"

        />
      </Link>
      <div className="content border border-top-0">
        <div>
          <span>{categoryName}</span>

          <p>
            <Link
              to={`${process.env.PUBLIC_URL
                }/p/${productData.fld_route?.replace(
                  /\s/g,
                  "-"
                ).replace('/', '')}`}
              className="p-0"
            >
              {itemName}
            </Link>
          </p>
        </div>
        <div className="d-lg-flex justify-content-between align-items-lg-end">
          <div className="price pb-lg-0 mt-2 mt-lg-0">
            &#x20B9; {parseInt(discountPrice)}{" "}
            {discountPrice < MRP && <del>&#x20B9; {parseInt(MRP)}</del>}
          </div>
          {/* {isInCart ? (
            <AddToCartQty
              itemid={variantId}
              quantity={isInCart.fld_quantity}
              cartlineid={isInCart.fld_cart_dtl_id}
            />
          ) : (
            <div to="" className="theme-btn">
              <AddToCart itemid={variantId} />

            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}
